import CalendarioCitas from './CalendarioCitas';

const Citas = () => {
  return <CalendarioCitas />;
};

export default Citas;